const Process = () => {
  const steps = [
    {
      number: "01",
      title: "Prise de contact",
      description:
        "Contactez votre ferrailleur épaviste à Saint-Étienne par téléphone ou via notre formulaire en ligne pour nous décrire votre besoin (enlèvement d'épave gratuit ou rachat de métaux).",
    },
    {
      number: "02",
      title: "Évaluation gratuite",
      description:
        "Pour le rachat de métaux, nous évaluons le type et la quantité. Pour l'enlèvement d'épave à Saint-Étienne et environs, nous vérifions les informations du véhicule.",
    },
    {
      number: "03",
      title: "Proposition tarifaire",
      description:
        "Nous vous communiquons nos meilleurs tarifs de rachat de métaux à Saint-Étienne (mis à jour hebdomadairement) ou confirmons l'enlèvement gratuit de votre épave.",
    },
    {
      number: "04",
      title: "Planification rapide",
      description:
        "Nous convenons d'une date d'intervention à Saint-Étienne, dans la Loire, la Haute-Loire ou le Rhône selon votre disponibilité, généralement sous 48h.",
    },
    {
      number: "05",
      title: "Intervention professionnelle",
      description:
        "Notre équipe de ferrailleur épaviste se déplace chez vous pour l'enlèvement gratuit de l'épave ou le rachat de vos métaux (cuivre, laiton, aluminium) au meilleur prix.",
    },
    {
      number: "06",
      title: "Paiement et finalisation",
      description:
        "Paiement immédiat pour le rachat de métaux et remise d'un certificat de cession pour l'enlèvement d'épave à Saint-Étienne et dans toute la Loire.",
    },
  ]

  return (
    <section id="fonctionnement" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Comment Fonctionne Votre Ferrailleur Épaviste à Saint-Étienne</h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Un processus simple et transparent en 6 étapes pour l'enlèvement gratuit de votre épave ou le rachat de vos
            métaux à Saint-Étienne et dans toute la Loire, la Haute-Loire et le Rhône.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md relative overflow-hidden">
              <div className="absolute -top-4 -left-4 bg-green-100 rounded-full w-24 h-24 flex items-center justify-center opacity-50"></div>
              <div className="relative">
                <span className="text-5xl font-bold text-green-200">{step.number}</span>
                <h3 className="text-xl font-bold mt-4 mb-3">{step.title}</h3>
                <p className="text-gray-700">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <h3 className="text-2xl font-bold mb-4">Des questions sur nos services d'épaviste à Saint-Étienne ?</h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Notre équipe de ferrailleur épaviste à Saint-Étienne est à votre disposition pour vous accompagner tout au long du processus et répondre à toutes
            vos questions concernant l'enlèvement gratuit d'épaves ou le rachat de métaux dans la Loire et la Haute-Loire.
          </p>
          <a
            href="#contact"
            className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-colors"
            aria-label="Contacter votre ferrailleur épaviste à Saint-Étienne"
          >
            Nous contacter
          </a>
        </div>
      </div>

      {/* Commentaire pour animation GSAP future */}
      {/* 
        Animation GSAP à implémenter:
        - Animation séquentielle des étapes
        - Effet de surbrillance au survol
      */}
    </section>
  )
}

export default Process
